import { render, staticRenderFns } from "./server-table.vue?vue&type=template&id=11ceea42&scoped=true&lang=pug&"
import script from "./server-table.vue?vue&type=script&lang=js&"
export * from "./server-table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11ceea42",
  null
  
)

export default component.exports